// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EC-z","modalContent":"FC-z","header":"GC-z","close":"HC-z"};